import mainService from "./mainService";
const path = "payment/billings";

export function records(page = 1) {
    return mainService
        .post(path + "/records/", { pagination: { page: page, perpage: 30 } })
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}
export function filter(item, page = 1) {
    return mainService
        .post(path + "/filter/", {
            pagination: { page: page, perpage: 30 },
            item: item
        })
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}
export function search(query, page = 1) {
    return mainService
        .post(path + "/search/", {
            pagination: { page: page, perpage: 30 },
            query: query
        })
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}
export function list() {
    return mainService
        .get(path + "/list/")
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}
export function remove(id) {
    return mainService
        .delete(path + "/delete/" + id)
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}
export function record(id) {
    return mainService
        .get(path + "/record/" + id)
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}
export function update(id, data) {
    return mainService
        .post(path + "/update/" + id, data)
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}
export function create(data) {
    return mainService
        .post(path + "/create/", data)
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}
export function invoice(id) {
    return mainService
        .get(path + "/invoice/" + id)
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}

export function manageSubscription(data) {
    return mainService
        .post(path + "/manage-subscription/", data)
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}

export function credits() {
    return mainService
        .get(path + "/credits")
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}

export function manageCredits(data) {
    return mainService
        .post(path + "/manage-credits/", data)
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}


// WEBPACK FOOTER //
// ./src/services/billing.jsx